import Vue from 'vue'
import contractTemplateApi from '@/api/contractTemplate.api'

const state = {
  templates: {},
  contractTemplatesTotalCount: 0
}


const getters = {
  contractTemplates: (state) => {
    return Object.values(state.templates) || []
  },

  contractTemplateById: (state) => (id) => {
    return state.templates[id] || null
  }
}


const actions = {
  async loadContractTemplates ({ commit, rootState }, { skip, take, search, sortBy, sortDesc }) {
    const response = await contractTemplateApi.getContractTemplates(rootState.tenant.current, skip, take, search, sortBy, sortDesc)
    commit('SET_TEMPLATES', { templates: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadContractTemplateById ({ commit, rootState }, id) {
    const response = await contractTemplateApi.getContractTemplate(rootState.tenant.current, id)
    commit('SET_TEMPLATE', response.data)
    return response.data
  },

  async loadAndUpdateContractTemplate ({ commit, rootState }, entityData) {
    const response = await contractTemplateApi.getContractTemplate(rootState.tenant.current, entityData.entityId)
    commit('UPDATE_TEMPLATE', response.data)
    return response.data
  },

  async createContractTemplate ({ commit, rootState }, template) {
    state.contractTemplatesTotalCount = state.contractTemplatesTotalCount + 1
    const response = await contractTemplateApi.createContractTemplate(rootState.tenant.current, template)
    commit('CREATE_TEMPLATE', response.data)
  },

  async updateContractTemplate ({ commit, rootState }, template) {
    await contractTemplateApi.updateContractTemplate(rootState.tenant.current, template.id, template)
    commit('UPDATE_TEMPLATE', template)
  },

  async deleteContractTemplate ({ commit, rootState }, templateId) {
    state.contractTemplatesTotalCount = state.contractTemplatesTotalCount - 1
    await contractTemplateApi.deleteContractTemplate(rootState.tenant.current, templateId)
    commit('DELETE_TEMPLATE', templateId)
  }
}


const mutations = {
  SET_TEMPLATES (state, { templates, count }) {
    state.templates = {}
    for (const template of templates) {
      Vue.set(state.templates, template.id, template)
    }
    state.contractTemplatesTotalCount = count
  },

  SET_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  CREATE_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  UPDATE_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  DELETE_TEMPLATE (state, id) {
    Vue.delete(state.templates, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
